interface RefundVerifyEntry {
  value?: number;
  refunds?: unknown[];
}

export function isChargeFullyRefunded(
  chargeStatus: string,
  responseVerify?: RefundVerifyEntry[],
): boolean {
  const legacyRefundHistory = responseVerify?.[0]?.refunds;
  return chargeStatus === "REFUND" && !(legacyRefundHistory?.length > 0);
}
